import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { CommunitySwimming } from 'images/latest'

const CommunitySwimmingIcon = ({ color = 'black' }) => (
  <ResponsiveSVG
    width='46px'
    height='33px'
    className='unstyled'
    fill={color}
    SVG={CommunitySwimming}
  />
)

export default CommunitySwimmingIcon
